<ni-card [bgColor]="'info'" [outline]="true" class="info-card">
    <h6 class="mt-0 title">FuelerLinx Fuel Orders @ {{ icao }}</h6>
    <div class="count">{{ totalOrders }}</div>
    <small *ngIf="dayDifference <= 60">(Last {{ dayDifference }} days) All FBOs &amp; All Fuel Sources</small>
    <small *ngIf="dayDifference > 60">(Last {{ monthDifference }} months) All FBOs &amp; All Fuel Sources</small>
    <mat-icon>local_gas_station</mat-icon>
</ni-card>

<div *ngIf="!options.useCard">Aircraft: {{ totalOrders }}</div>
